import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncOperationHandler } from '../../../helpers/redux-helpers';
import { MapUnknownAnimalModel } from 'shared/api/api';

export const getUnknownAnimals = createAsyncThunk('unknownAnimals/getUnknownAnimals', (siteId: string) => {
	return AsyncOperationHandler(client => client.unknownAnimal_GetUnknownAnimalsBySiteId(siteId));
});

export const mapUnknownAnimals = createAsyncThunk('unknownAnimals/mapUnknownAnimals', (mapUnknownAnimalModels: MapUnknownAnimalModel[]) => {
	return AsyncOperationHandler(client => client.unknownAnimal_MapUnknownAnimals(mapUnknownAnimalModels));
});